
import { useState } from "react";
import { Link } from "react-router-dom";


export default function ContactoFAQ() {
  // clave de la sección abierta: "contacto" | "envio" | "pagos" | "cambios" | null
  const [open, setOpen] = useState(null);
  const toggle = (key) => setOpen((prev) => (prev === key ? null : key));

  const rowBase = "w-full flex items-center justify-between py-4 md:py-5";
  const rowTitle = "text-base md:text-lg font-medium";
  const chevronCls = "h-5 w-5 shrink-0 transition-transform duration-300";
  const innerPad = "px-4 md:px-5";

  return (
    <div className="pb-20 pt-48 md:pt-44 text-gray-800">
      {/* Desde acá empieza el color arena (de borde a borde) */}
      <section className="w-full bg-[#ffae00]">
        <div className={`max-w-3xl mx-auto ${innerPad} py-8 md:py-12`}>
          {/* Título (sin flecha) */}
          <h1 className="text-3xl md:text-4xl font-semibold mb-4 md:mb-6">
            Preguntas frecuentes
          </h1>

          {/* CONTACTO */}
          <div>
            <button
              className={rowBase}
              aria-expanded={open === "contacto"}
              aria-controls="panel-contacto"
              onClick={() => toggle("contacto")}
            >
              <span className={rowTitle}>Contacto</span>
              <svg
                className={`${chevronCls} ${open === "contacto" ? "rotate-180" : "rotate-0"}`}
                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 111.04 1.08l-4.24 3.36a.75.75 0 01-.94 0L5.21 8.31a.75.75 0 01.02-1.1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <Collapsible id="panel-contacto" open={open === "contacto"}>
              <p className="mb-2">Dudas generales o soporte:</p>
              <p className="font-medium">wetsoulconsultas@gmail.com</p>
            </Collapsible>
            {/* Separador corto (no ocupa todo el ancho) */}
            <div className="mx-4 md:mx-5 border-t border-black/15" />
          </div>

          {/* ENVÍO */}
          <div>
            <button
              className={rowBase}
              aria-expanded={open === "envio"}
              aria-controls="panel-envio"
              onClick={() => toggle("envio")}
            >
              <span className={rowTitle}>Envío</span>
              <svg
                className={`${chevronCls} ${open === "envio" ? "rotate-180" : "rotate-0"}`}
                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 111.04 1.08l-4.24 3.36a.75.75 0 01-.94 0L5.21 8.31a.75.75 0 01.02-1.1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <Collapsible id="panel-envio" open={open === "envio"}>
              <p className="mb-2">
                Enviamos a <strong>toda Argentina</strong> mediante Correo Argentino.
              </p>
              <p className="mb-2">
                Tiempo estimado: <strong>4–5 días hábiles</strong> (según plazos del correo).
              </p>
              <p className="mb-0">
                El costo se calcula automáticamente al finalizar la compra según tu dirección.
              </p>
            </Collapsible>
            <div className="mx-4 md:mx-5 border-t border-black/15" />
          </div>

          {/* PAGOS */}
          <div>
            <button
              className={rowBase}
              aria-expanded={open === "pagos"}
              aria-controls="panel-pagos"
              onClick={() => toggle("pagos")}
            >
              <span className={rowTitle}>Medios de pago</span>
              <svg
                className={`${chevronCls} ${open === "pagos" ? "rotate-180" : "rotate-0"}`}
                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 111.04 1.08l-4.24 3.36a.75.75 0 01-.94 0L5.21 8.31a.75.75 0 01.02-1.1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <Collapsible id="panel-pagos" open={open === "pagos"}>
              <p>
                <strong>Mercado Pago</strong> — tarjeta de crédito/débito, dinero en cuenta y efectivo (Rapipago/Pago Fácil).
              </p>
              <p className="text-gray-800 font-semibold">
                Transferencia bancaria — 15% OFF
              </p>
            </Collapsible>
            <div className="mx-4 md:mx-5 border-t border-black/15" />
          </div>

          {/* CAMBIOS Y DEVOLUCIONES */}
          <div>
            <button
              className={rowBase}
              aria-expanded={open === "cambios"}
              aria-controls="panel-cambios"
              onClick={() => toggle("cambios")}
            >
              <span className={rowTitle}>Cambios y devoluciones</span>
              <svg
                className={`${chevronCls} ${open === "cambios" ? "rotate-180" : "rotate-0"}`}
                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 111.04 1.08l-4.24 3.36a.75.75 0 01-.94 0L5.21 8.31a.75.75 0 01.02-1.1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <Collapsible id="panel-cambios" open={open === "cambios"}>
              <p className="mb-0">
                <span>Leé nuestra </span>
                <Link to="/devolucion" className="underline font-medium">
                  Ver Política de Devolución
                </Link>
              </p>
            </Collapsible>
            {/* Fin del color arena después de este bloque */}
          </div>
        </div>
      </section>
    </div>
  );
}

/** Contenido colapsable con animación de altura suave */
function Collapsible({ id, open, children }) {
  return (
    <div
      id={id}
      role="region"
      aria-hidden={!open}
      className={`grid transition-[grid-template-rows] duration-300 ease-out ${
        open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
      }`}
    >
      <div className="overflow-hidden">
        <div className="px-1 pb-4 md:pb-5">{children}</div>
      </div>
    </div>
  );
}